var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.3542C5.56418 21.3542 1.14584 16.9358 1.14584 11.5C1.14584 6.06418 5.56418 1.64584 11 1.64584C16.4358 1.64584 20.8542 6.06418 20.8542 11.5C20.8542 16.9358 16.4358 21.3542 11 21.3542ZM11 3.02084C6.32501 3.02084 2.52084 6.82501 2.52084 11.5C2.52084 16.175 6.32501 19.9792 11 19.9792C15.675 19.9792 19.4792 16.175 19.4792 11.5C19.4792 6.82501 15.675 3.02084 11 3.02084Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69832 14.7817C9.51499 14.7817 9.34082 14.7083 9.21249 14.58L6.61832 11.9858C6.35249 11.72 6.35249 11.28 6.61832 11.0142C6.88415 10.7483 7.32415 10.7483 7.58999 11.0142L9.69832 13.1225L14.41 8.41083C14.6758 8.145 15.1158 8.145 15.3817 8.41083C15.6475 8.67666 15.6475 9.11666 15.3817 9.3825L10.1842 14.58C10.0558 14.7083 9.88165 14.7817 9.69832 14.7817Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.9b6f047d6122e0078ed9276565f8687b.svg";
export { ForwardRef as ReactComponent };